import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export abstract class Subscribable {
  protected subscriptions: Subscription[] = [];

  subscribe() {
    this.subscribeToObservables();
  }

  protected abstract subscribeToObservables(): void;

  unsubscribe() {
    if (this.subscriptions) {
      for (const sub of this.subscriptions) {
        sub.unsubscribe();
      }
    }
  }
}
